var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "iframe-widget" },
    [
      _c(
        "div",
        { staticClass: "widget-header" },
        [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "i",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        placement: "top",
                        theme: "light",
                        arrow: true,
                        animation: "scale-extreme",
                        duration: [200, 200],
                        hideOnClick: true,
                      },
                      expression:
                        "{\n                    placement: 'top',\n                    theme: 'light',\n                    arrow: true,\n                    animation: 'scale-extreme',\n                    duration: [200, 200],\n                    hideOnClick: true,\n                }",
                    },
                  ],
                  staticClass: "material-icons drag-handle",
                  attrs: { content: "Sürükleyerek taşıyabilirsiniz" },
                },
                [_vm._v("drag_indicator")]
              ),
              _vm._v(" "),
              _c("widget-title", {
                attrs: { widget: _vm.widget, table: _vm.table },
                on: { "widget-updated": _vm.handleWidgetUpdated },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("widget-actions", {
            attrs: {
              title: _vm.widget.title,
              widget: _vm.widget,
              table: _vm.table,
            },
            on: {
              fullscreen: _vm.handleFullscreen,
              edit: _vm.handleEdit,
              rename: _vm.handleRename,
              duplicate: _vm.handleDuplicate,
              dock: _vm.handleDock,
              export: _vm.handleExport,
              delete: function ($event) {
                return _vm.$emit("delete", _vm.widget._id)
              },
              "widget-updated": _vm.handleWidgetUpdated,
              "widget-duplicated": _vm.handleWidgetDuplicated,
              "widget-deleted": _vm.handleWidgetDeleted,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "widget-content" },
        [
          !_vm.hasValidSettings
            ? _c("empty-widget", {
                attrs: {
                  error: null,
                  "has-valid-settings": _vm.hasValidSettings,
                },
                on: { edit: _vm.handleEdit },
              })
            : _c("iframe", {
                key: _vm.refreshKey,
                staticClass: "iframe-content",
                attrs: {
                  src: _vm.widget.settings.url,
                  height: _vm.widget.settings.height,
                  frameborder: "0",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSettingsModal
        ? _c("iframe-settings-modal", {
            attrs: {
              visible: _vm.showSettingsModal,
              widget: _vm.widget,
              table: _vm.table,
            },
            on: {
              close: function ($event) {
                _vm.showSettingsModal = false
              },
              save: _vm.handleSettingsSave,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }